import tw, { styled } from 'twin.macro'
import { motion, AnimatePresence } from 'framer-motion'
import { useAtomValue } from 'jotai'

import { claimSpiritStageAnimateAtom } from './atoms/claimSpiritStageAtom'

const DescInfo = styled(motion.div)`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 18.5vh;

  div {
    ${tw`font-primary font-bold`}
    color: #ffffff;
    font-size: 1.25vw;
  }

  p {
    ${tw`font-primary`}
    font-size: 0.833vw;
    color: #36fad7;
    margin-top: 2.83vh;
    text-align: center;
  }
`

export default function TopSection() {
  const variants = useAtomValue(claimSpiritStageAnimateAtom)
  return (
    <AnimatePresence mode="wait">
      <DescInfo
        animate="animate"
        variants={variants.topSection}
      >
        <div>WAKE UP...SURVIVORS... AWAKEN YOUR SPIRIT...</div>
        <p>COME AND SAVE THE BROKEN WORLD</p>
      </DescInfo>
    </AnimatePresence>
  )
}
